import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../auth';
import { Role } from '../auth/roles';

export const canActivateRole = (requiredRole: Role): CanActivateFn => {
    return () => {
        const auth = inject(AuthService);
        const router = inject(Router);
        const roles = auth.getRolesArray();

        if (roles.includes(requiredRole)) {
            return true;
        }

        router.navigateByUrl('/');
        return false;
    };
};
